import type { SearchFilters, SearchFiltersOptions } from '@rover/types';
import {
  ADVANCED_FILTER_FIELDS,
  STAFF_ONLY_FIELDS,
} from '@rover/shared/js/constants/searchPage.constants';

const staffOnlyFiltersCounter = (
  filters: Partial<SearchFilters>,
  serviceTypeOptions: Partial<SearchFiltersOptions>
) => {
  return Object.keys(filters).reduce((accum, filterName) => {
    if (
      !STAFF_ONLY_FIELDS.has(filterName) ||
      !Object.keys(serviceTypeOptions).includes(filterName)
    ) {
      return accum;
    }
    if (Array.isArray(filters[filterName])) {
      return accum + filters[filterName].length;
    }
    return filters[filterName] ? accum + 1 : accum;
  }, 0);
};

const advancedFiltersCounter = (
  filters: Partial<SearchFilters>,
  serviceTypeOptions?: Partial<SearchFiltersOptions>
): number => {
  if (!serviceTypeOptions) {
    return 0;
  }
  const options = new Set(Object.keys(serviceTypeOptions));
  return (
    Object.entries(filters).filter(([filterName, filterValue]) =>
      options.has(filterName) && ADVANCED_FILTER_FIELDS.has(filterName) ? filterValue : false
    ).length + staffOnlyFiltersCounter(filters, serviceTypeOptions)
  );
};

export default advancedFiltersCounter;
